import { SelectableButtonsProps } from '@src/components/sco/SelectableButtons'
import { GiTeacher } from 'react-icons/gi'
import { LuBadgeDollarSign, LuHammer, LuHandshake, LuSearch, LuTrophy, LuUsersRound } from 'react-icons/lu'

export const groupRequestTypes = [
  {
    id: 'goal',
    key: 'goal',
    title: 'Goal',
    label: 'Another Goal',
    colorHexCode: '#5F7495',
    icon: LuTrophy,
    signupResultLabel: 'a game plan',
  },
  {
    id: 'funding',
    key: 'funding',
    title: 'Funding',
    label: 'Raise Funding',
    description: 'TBD',
    colorHexCode: '#38908A',
    icon: LuBadgeDollarSign,
    skillTitle: 'advisor',
    signupResultLabel: 'investor matches',
  },
  {
    id: 'get-customers',
    key: 'get-customers',
    title: 'Get Customers',
    label: 'Get Customers',
    description: 'TBD',
    colorHexCode: '#BE4444',
    icon: LuSearch,
    skillTitle: 'customer acquisition',
    signupResultLabel: 'marketing matches',
  },
  {
    id: 'build-product',
    key: 'build-product',
    title: 'Build Product',
    label: 'Build Product',
    description: 'TBD',
    colorHexCode: '#385564',
    icon: LuHammer,
    skillTitle: 'product',
    signupResultLabel: 'product matches',
  },
  {
    id: 'cofounder',
    key: 'cofounder',
    title: 'Co-founder',
    label: 'Find a Co-founder',
    description: 'TBD',
    colorHexCode: '#872341',
    icon: LuUsersRound,
    skillTitle: 'co-founder',
    signupResultLabel: 'co-founder matches',
  },
  {
    id: 'advisor',
    key: 'advisor',
    title: 'Advisor',
    label: 'Find Advisors',
    description: 'TBD',
    colorHexCode: '#4A47A3',
    icon: GiTeacher,
    skillTitle: 'advisor',
    signupResultLabel: 'advisor matches',
  },
  {
    id: 'talent',
    key: 'talent',
    title: 'Talent',
    label: 'Hire Talent',
    description: 'TBD',
    colorHexCode: '#46B5D1',
    icon: LuHandshake,
    skillTitle: 'candidate',
    signupResultLabel: 'hiring matches',
  },
]

export const groupRequestTypesSelectableButtonOptions: SelectableButtonsProps['options'] = groupRequestTypes
  .filter(t => !['goal'].includes(t.key))
  .map(t => ({
    key: t.key,
    title: t.label || t.title,
    selectableButtonProps: {
      activeColor: t.colorHexCode,
      iconPlacement: 'top',
      icons: {
        default: t.icon,
        selected: t.icon,
      },
      buttonProps: {
        flexGrow: 1,
        paddingY: 4,
        borderWidth: '1px',
        _hover: {
          backgroundColor: t.colorHexCode,
          borderColor: t.colorHexCode,
          color: 'white',
        },
      },
    },
  }))
